import { useContext } from 'react'
import { isWithinInterval, parseISO, add } from 'date-fns'
import BootstrapDataContext from '../../context/BootstrapDataContext'

export default function useCurrentBooking() {
  const {
    mostRecentBooking: { current, future }
  } = useContext(BootstrapDataContext)
  const today = new Date()
  const currentTrip = current?.currentTrip
  const futureBooking =
    future?.productId === 5 &&
    isWithinInterval(parseISO(future?.travelStartDateTime), {
      start: today,
      end: add(today, { days: 7 })
    })
      ? {
          travelEndDateTime: future.travelEndDateTime,
          cityName: future.destinationCity,
          hotelID: future.hotelId,
          numRooms: future.numHotelRooms
        }
      : null
  return currentTrip?.type === 'STAY'
    ? {
        travelEndDateTime: currentTrip.travelEndDateTime,
        cityName: currentTrip.cityName,
        hotelID: currentTrip.hotelID,
        numRooms: currentTrip.numRooms
      }
    : futureBooking
}
